import _ from 'lodash'

export const createMessageSelector = () => (state) => {
    return _.get(state, `message`)
}